import React, { useState, useEffect } from 'react';
import '../css/partnersPage.css';
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";
import { useMobileMediaQuery, useTabletMediaQuery } from '../utils';
import usePagination from '@mui/material/usePagination';
import { styled, useTheme } from '@mui/material/styles';

const ListPagination = (props) => {

    const {
        numPage,
        pageNumber,
        setPageSelected,
    } = props;

    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();

    const List = styled('ul')({
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
    });

    const { items } = usePagination({
        count: numPage,
        page: pageNumber,
        onChange: (event, page) => {
            setPageSelected(page);
        },
        siblingCount: 1,
    });

    useEffect(() => {
        if (pageNumber > 0 && pageNumber <= numPage) {
            setPageSelected(pageNumber);
        }
    }, [pageNumber, numPage, setPageSelected]);

  return (
    <div className='mainPaginationViewContainerPartnersPage'>
        <nav>
            <List className='customPaginationListPartnersPage'>
                {items.map(({ page, type, selected, ...item }, index) => {
                let children = null;

                if (type === 'start-ellipsis' || type === 'end-ellipsis') {
                    children = '…';
                } else if (type === 'page') {
                    children = (
                    <button
                        type="button"
                        className={ selected ? 'customPaginationPartnersPageSelected' : 'customPaginationPartnersPage' }
                        {...item}
                    >
                        {page}
                    </button>
                    );
                } else {
                    children = (
                    <button 
                        type="button" 
                        {...item}
                        className='customPaginationNavIconViewPartnersPage'
                    >
                        {type === 'next' ?  <FaAngleRight className='customPaginationNavIconPartnersPage'/> : <FaAngleLeft className='customPaginationNavIconPartnersPage'/>}
                    </button>
                    );
                }

                return <li key={index}>{children}</li>;
                })}
            </List>
        </nav>
    </div>
  )
}

export default ListPagination;